import React from "react";
import {createRoot} from "react-dom/client";

import CMS from "./CMS/CMS";

const container = document.getElementById('root');
const root = createRoot(container as any);
root.render(<CMS/>);
